module.exports = __webpack_public_path__ + "static/media/PositiveSmiley.3dfee67b.png";